var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 26C27.866 26 31 22.866 31 19C31 15.134 27.866 12 24 12C20.134 12 17 15.134 17 19C17 22.866 20.134 26 24 26Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22C25.6569 22 27 20.6569 27 19C27 17.3431 25.6569 16 24 16C22.3431 16 21 17.3431 21 19C21 20.6569 22.3431 22 24 22Z",
    fill: "#DA2E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 4C19.7844 3.99979 15.7388 5.66352 12.7427 8.62958C9.74671 11.5956 8.0424 15.6243 8.00024 19.84C8.00024 30.8 22.1002 43 22.7002 43.52C23.0625 43.8299 23.5235 44.0001 24.0002 44.0001C24.4769 44.0001 24.938 43.8299 25.3002 43.52C26.0002 43 40.0002 30.8 40.0002 19.84C39.9581 15.6243 38.2538 11.5956 35.2578 8.62958C32.2617 5.66352 28.2161 3.99979 24.0002 4ZM24.0002 26C22.6158 26 21.2624 25.5895 20.1113 24.8203C18.9601 24.0511 18.0629 22.9579 17.5331 21.6788C17.0033 20.3997 16.8646 18.9922 17.1347 17.6344C17.4048 16.2765 18.0715 15.0292 19.0505 14.0503C20.0295 13.0713 21.2767 12.4046 22.6346 12.1345C23.9925 11.8644 25.3999 12.003 26.679 12.5328C27.9581 13.0627 29.0514 13.9599 29.8205 15.111C30.5897 16.2622 31.0002 17.6155 31.0002 19C31.0002 20.8565 30.2627 22.637 28.95 23.9497C27.6372 25.2625 25.8568 26 24.0002 26Z",
    fill: "#DA2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinMaps);
export default __webpack_public_path__ + "static/media/pinMaps.f95d8fdcf3db5ac9a2f3ca3f972e3cb9.svg";
export { ForwardRef as ReactComponent };